import { render, staticRenderFns } from "./CheckoutDenied.vue?vue&type=template&id=01ed08b6&scoped=true"
import script from "./CheckoutDenied.vue?vue&type=script&lang=js"
export * from "./CheckoutDenied.vue?vue&type=script&lang=js"
import style0 from "./CheckoutDenied.vue?vue&type=style&index=0&id=01ed08b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ed08b6",
  null
  
)

export default component.exports